import Axios from "axios";

export const listCountries = fields => {
  return Axios.get(
    `https://hv-api-staging.herokuapp.com/data/countries`
  );
};
